import { render, staticRenderFns } from "./casesDetail.vue?vue&type=template&id=bbcfcdc0&scoped=true"
import script from "./casesDetail.vue?vue&type=script&lang=js"
export * from "./casesDetail.vue?vue&type=script&lang=js"
import style0 from "./casesDetail.vue?vue&type=style&index=0&id=bbcfcdc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcfcdc0",
  null
  
)

export default component.exports